export function Spinner() {
  return (
    <div
      className="h-6 w-6 animate-spin rounded-lg border-2 border-nova-primary border-t-transparent"
      role="status"
      aria-label="Loading"
    />
  );
}
